import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { HandballFixture, HandballPeriod } from '@ps/web-shared-generated-graphql/sports';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';
import FormatEventStatusDuration from '../FormatEventStatusDuration/FormatEventStatusDuration';
import GameTime from '../GameTime/GameTime';

import {
  TXTWCL_End_of_Overtime,
  TXTWCL_End_of_Q1,
  TXTWCL_End_of_Q2,
  TXTWCL_Game_Ended,
  TXTWCL_Going_In_PlayXX,
  TXTWCL_In_Play,
  TXTWCL_Overtime,
  TXTWCL_Penalties,
  TXTWCL_Q1,
  TXTWCL_Q2
} from './HandballScoreboardInPlayStatus.messages.json';

const mapHandballPeriodToTranslationTag = (period: HandballPeriod): TranslationTag => {
  switch (period) {
    case 'PRE_MATCH':
      return TXTWCL_Going_In_PlayXX;
    case 'PERIOD_1':
      return TXTWCL_Q1;
    case 'PERIOD_2':
      return TXTWCL_Q2;
    case 'END_PERIOD_1':
      return TXTWCL_End_of_Q1;
    case 'END_PERIOD_2':
      return TXTWCL_End_of_Q2;
    case 'OVERTIME':
      return TXTWCL_Overtime;
    case 'END_OVERTIME':
      return TXTWCL_End_of_Overtime;
    case 'END':
      return TXTWCL_Game_Ended;
    case 'UNKNOWN_PERIOD':
      return TXTWCL_In_Play;
    case 'PENALTIES':
      return TXTWCL_Penalties;
    default:
      return TXTWCL_In_Play;
  }
};

interface Props {
  handballFixture: HandballFixture;
}

const HandballScoreboardInPlayStatus: React.FC<Props> = ({ handballFixture }) => {
  const { score, clock } = handballFixture;
  const eventStatusMessage = <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;

  if (!score || !clock) {
    return eventStatusMessage;
  }

  switch (clock.period) {
    case 'END':
    case 'END_PERIOD_1':
    case 'END_PERIOD_2':
    case 'END_OVERTIME':
    case 'PENALTIES':
    case 'PRE_MATCH':
    case 'UNKNOWN_PERIOD':
      return (
        <GameTime>
          <span>
            <Translation {...mapHandballPeriodToTranslationTag(clock.period)} />
          </span>
        </GameTime>
      );
    case 'PERIOD_1':
    case 'PERIOD_2':
    case 'OVERTIME':
      return (
        <GameTime>
          <span>
            <Translation {...mapHandballPeriodToTranslationTag(clock.period)} />
            <FormatEventStatusDuration intervalInSeconds={clock.timeElapsed} />
          </span>
        </GameTime>
      );
    default:
      return eventStatusMessage;
  }
};

export default HandballScoreboardInPlayStatus;
